import React from 'react';
import { AtsAsset } from '../../components/ATS/ats-asset';
import { AtsItemOverwrites } from '../../components/ATS/ats-asset/atsAsset.interfaces';
import { AtsBanner } from '../../components/ATS/AtsBanner/AtsBanner';
import AtsGenre from '../../components/ATS/AtsGenre/AtsGenre';
import { AtsKidsService } from '../../components/ATS/AtsKidsService/AtsKidsService';
import AtsPerson from '../../components/ATS/AtsPerson/AtsPerson';
import AtsPromo from '../../components/ATS/AtsPromo/AtsPromo';
import { AtsStreamingService } from '../../components/ATS/AtsStreamingService/AtsStreamingService';
import { Layout } from '../../queries/ats/layout/types';
import { warn } from '../../utils/commonUtils';
import { InputContext } from '../ats-details/use-input-context';

interface PatternHandlerProps {
  pattern: Layout.Pattern;
  item: Layout.SectionItem;
  params?: Partial<InputContext>;
  overwrites?: AtsItemOverwrites;
}

export function PatternHandler({ pattern, item, params, overwrites, ...rest }: PatternHandlerProps) {
  switch (pattern) {
    case 'wide':
    case 'wide-notext-double':
    case 'wide-notext-large':
    case 'poster':
    case 'poster-notext':
      return <AtsAsset item={item} pattern={pattern} params={params} overwrites={overwrites} {...rest} />;
    case 'promo-wide':
    case 'promo-single':
    case 'promo-wide-large':
      return <AtsPromo item={item} pattern={pattern} overwrites={overwrites} {...rest} />;
    case 'genre':
      return <AtsGenre item={item} pattern={pattern} overwrites={overwrites} {...rest} />;
    case 'streaming-service':
      return <AtsStreamingService item={item} pattern={pattern} overwrites={overwrites} {...rest} />;
    case 'banner-fullscreen':
      return <AtsBanner item={item} pattern={pattern} overwrites={overwrites} {...rest} />;
    case 'person':
      return <AtsPerson item={item} pattern={pattern} overwrites={overwrites} {...rest} />;
    case 'kids-service':
      return <AtsKidsService item={item} pattern={pattern} overwrites={overwrites} {...rest} />;
    default:
      warn(`Missing component for pattern: ${pattern}`);
      return null;
  }
}

function PatternHandlerSkeleton({ pattern }: Pick<PatternHandlerProps, 'pattern'>) {
  switch (pattern) {
    case 'wide':
    case 'wide-notext-double':
    case 'wide-notext-large':
    case 'poster':
    case 'poster-notext':
      return <AtsAsset.Skeleton pattern={pattern} />;
    case 'promo-wide':
    case 'promo-single':
    case 'promo-wide-large':
      return <AtsPromo.Skeleton pattern={pattern} />;
    case 'genre':
      return <AtsGenre.Skeleton pattern={pattern} />;
    case 'streaming-service':
      return <AtsStreamingService.Skeleton pattern={pattern} />;
    case 'banner-fullscreen':
      return <AtsBanner.Skeleton />;
    case 'person':
      return <AtsPerson.Skeleton />;
    case 'kids-service':
      return <AtsKidsService.Skeleton />;
    default:
      warn(`Missing skeleton for pattern: ${pattern}`);
      return null;
  }
}

PatternHandler.Skeleton = PatternHandlerSkeleton;
